import MaterialIcon from "material-icons-react";
import Dropzone from "react-dropzone";
import React from "react";
import './index.scss';

const Upload = (props) => {
    return (
        <div className="library-document">
            <div className="fileupload">
                <div className="upload-icon">
                    <img src="/images/icons/SVG/Upload-red.svg" alt="upload"/>
                </div>
                <h4 className="upload-title">
                    Drag & Drop
                </h4>
                <div className="form-group">
                    <Dropzone
                        accept={props.accept}
                        minSize={0}
                        onDrop={x => {
                            props.sendFiles(x);
                        }}
                    >
                        {({
                              getRootProps,
                              getInputProps,
                              isDragActive,
                              isDragReject
                          }) => {
                            return (
                                <div {...getRootProps()} className="dropZone">
                                    <input {...getInputProps()} name={props.name}/>
                                    {!isDragActive &&
                                    <span>Or you can <u>browse</u> your files</span>}
                                    {isDragActive &&
                                    !isDragReject &&
                                    "Drop it like it's hot!"}
                                    {isDragReject &&
                                    "File type not accepted, sorry!"}
                                </div>
                            );
                        }}
                    </Dropzone>
                </div>
            </div>
            {props.accept && 
                <div className="accepted-formats">Accepted Formats: {props.accept}</div>}
        </div>
    );
}

export default Upload;
